import { Col, Form, Input, Row } from "antd"
import { Store } from "antd/lib/form/interface"
import React from "react"
import { useTranslation } from "react-i18next"
import { generateRules } from "./rules/bugReport.rules"
import { FormInstance } from "antd/lib/form"
const { TextArea } = Input

interface BugReportInterface {
    formInstance: FormInstance
    handleSubmit: (values: Store) => void
}
const BugReportForm: React.FC<BugReportInterface> = ({ formInstance, handleSubmit }) => {
    const { t } = useTranslation()

    const rules = generateRules()

    return (
        <div>
            <Form form={formInstance} layout="vertical" onFinish={handleSubmit}>
                <Row gutter={[16, 16]}>
                    <Col span={24} sm="24">
                        <Form.Item label={t("input:message")} name="message" rules={rules.message}>
                            <TextArea className="mt-10" autoSize={{ minRows: 4, maxRows: 10 }} placeholder={t("placeholder:bug_report_message")} required></TextArea>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

export default BugReportForm
